import Icon from "./logo";
var CnLayoutRowPrototype = {
  title: '行',
  componentName: 'CnLayoutRow',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  configure: [{
    name: 'isCnLayoutRow',
    title: 'CnLayoutRow',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutRowPrototype };